import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { SignOut, House, FolderOpen, Plus, User } from "@phosphor-icons/react";

const LOGO_URL =
  "/vznlogo.png";

export function ClientLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { to: "/", label: "Home", icon: House },
    { to: "/dashboard", label: "Projects", icon: FolderOpen },
    { to: "/request/new", label: "Request Quote", icon: Plus },
    { to: "/account", label: "Account", icon: User },
  ];

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#050505] text-[#fafafa] pb-20 md:pb-0">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#050505]/70 border-b border-[#262626]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="brand-link" title="Back to home">
            <img src={LOGO_URL} alt="Vision Grafix · Back to home" className="w-[10rem] md:w-[13rem] h-auto object-contain" />
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}
                className={`nav-underline transition-colors ${
                  location.pathname === item.to ? "text-[#FF2D2D]" : "text-[#a3a3a3] hover:text-white"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-2 md:gap-4">
            <span className="hidden md:block text-xs text-[#a3a3a3]" data-testid="user-name">
              {user?.name}
            </span>
            <button
              onClick={handleLogout}
              data-testid="logout-button"
              className="btn-outline px-3 py-1.5 text-sm flex items-center gap-2"
            >
              <SignOut size={16} />
              <span className="hidden sm:inline">Sign out</span>
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">{children}</main>

      {/* Mobile bottom nav */}
      <nav
        className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0a0a0a]/95 backdrop-blur-xl border-t border-[#262626] grid grid-cols-4"
        data-testid="mobile-nav"
      >
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.to;
          return (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(" ", "-")}`}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] uppercase tracking-wider transition-colors ${
                isActive ? "text-[#FF2D2D]" : "text-[#a3a3a3] hover:text-white"
              }`}
            >
              <Icon size={18} weight={isActive ? "fill" : "regular"} />
              {item.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
